import { RoomCountRange } from '@immosky/types';
import { createAction, props } from '@ngrx/store';

export enum RoomCountActions {
  Reset = '[Filter] Reset Room Count Filter',
  Set = '[Filter] Set Room Count Filter',
  SetBasedOnValues = '[Filter] Set Room Count Filter Based On Values',
}

export const resetRoomCountFilter = createAction(RoomCountActions.Reset);

export const setRoomCountFilter = createAction(
  RoomCountActions.Set,
  props<{ filter: RoomCountRange }>()
);

export const setRoomCountFilterBasedOnUrlValues = createAction(
  RoomCountActions.SetBasedOnValues,
  props<{ values: { min: number; max: number } }>()
);
